
import Auth from './Auth/sagas';
import Pets from './Pets/sagas';
import Clients from './Clients/sagas';
import Treatments from './Treatments/sagas';

export default [
  Auth,
  Pets,
  Clients,
  Treatments,
];
